import React, { useEffect, useMemo, useRef } from 'react';
import { Button, Tab, Tabs } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import ComponentCustomerInfo from './components/customerSiteInfo';
import {
  selectedTabStyles, tabStyles, tabsStyles, stylesTabIndicator,
} from '../../../../Common/TabsStyles';
import ComponentPageHeader from '../../../../Common/PageHeader/ComponentPageHeader';
import ComponentTravelInfo from './components/travelInfo';
import {
  clearJobScheduleUnitData, getSchedulingPdfData, resetSchedulingPdfData, setSelectedTab,
} from './redux/jobScheduleSlice';
import { RootState } from '../../../../redux/rootState';
import ScreenLetterPdf from '../../Pdf';
import { setLoader } from '../../../../redux/loaderSlice';
import { clearSelectedJobSite } from '../../../Job/jobStarter/addJob/redux/addJobSlice';

export default function EditJobSchedule() {
  const { jobId, bidId } = useParams();
  const dispatch = useDispatch();
  const printRef = useRef(null);
  const targetDivRef = useRef<HTMLDivElement | null>(null);
  const { jobScheduleUnitData, schedulingPdfResponse } = useSelector((state: RootState) => state.jobScheduleReducer);

  const goToTop = () => {
    const targetDiv = targetDivRef.current;
    targetDiv?.scrollTo({
      top: 0,
      behavior: 'auto',
    });
  };
  const isUnScheduleJob = useMemo(() => {
    const getUrl = window.location.href;
    return getUrl && getUrl?.includes('unscheduled-jobs');
  }, []);

  const handleUnmountPdf = () => {
    dispatch(setLoader(false));
    dispatch(resetSchedulingPdfData());
  };

  const handlePrint = useReactToPrint({
    content: () => printRef?.current,
    removeAfterPrint: true,
    copyStyles: true,
    onAfterPrint() {
      handleUnmountPdf();
    },
    documentTitle: `WO_${jobId}`,
  });

  const TABS = [
    { id: 1, label: 'Units', component: <ComponentCustomerInfo /> },
    { id: 2, label: 'Travel Info', component: <ComponentTravelInfo /> },
  ];
  const { selectedTab } = useSelector((state: RootState) => state.jobScheduleReducer);

  const handleChangeTab = (tabId: number) => {
    dispatch(setSelectedTab(tabId));
  };

  const handlePdf = () => {
    dispatch(setLoader(true));
    const pay = {
      BidId: bidId || '',
      JobOrders: jobScheduleUnitData?.Data?.map((item: { UnitId: string }) => item?.UnitId),
    };
    dispatch(getSchedulingPdfData(pay));
  };

  useEffect(() => {
    if (schedulingPdfResponse?.length > 0) {
      handlePrint();
    } else if (schedulingPdfResponse?.length === 0) {
      setLoader(false);
    }
  }, [schedulingPdfResponse]);

  useEffect(() => () => {
    dispatch(clearSelectedJobSite());
    dispatch(clearJobScheduleUnitData());
  }, []);

  return (
    <>
      <ComponentPageHeader subHeading={`JOB # ${jobId}`} fieldId={jobId ?? ''} fieldName="Job ID" />
      <div className="container_job">
        <Tabs
          variant="scrollable"
          value={selectedTab - 1}
          onChange={(_, newValue) => handleChangeTab(TABS[newValue].id)}
          style={tabsStyles}
          TabIndicatorProps={stylesTabIndicator}
        >
          {TABS.map((tab) => (
            <Tab
              key={tab.id}
              label={tab.label}
              style={selectedTab === tab.id ? selectedTabStyles : tabStyles}
              className="tab_styles"
              onClick={goToTop}
            />
          ))}
        </Tabs>
        {!isUnScheduleJob && (
        <Button
          type="button"
          className="button_save_and_next"
          onClick={handlePdf}
        >
          Generate WO
        </Button>
        )}
      </div>
      <div className="div_job_container_info" ref={targetDivRef}>
        <div className="div_container_CustomerInfo">
          {TABS[selectedTab - 1].component}
        </div>
      </div>
      <ScreenLetterPdf printRef={printRef} />
    </>
  );
}
